import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { responseJson } from "../../utils/tradeApi";
import "./trade.css";

export default function TradePdfViewer() {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let objectUrl = "";
    fetch(`/api/trade/files/${fileId}/content`)
      .then(async (response) => {
        if (!response.ok) {
          await responseJson(response);
        }
        return response.blob();
      })
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        setSource(objectUrl);
      })
      .catch((requestError) => setError(requestError.message));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId]);

  return (
    <main className="trade-pdf-page">
      <header>
        <button className="trade-button secondary" onClick={() => navigate(-1)}>← Back to drawings</button>
        <strong>PDF Viewer</strong>
        <span />
      </header>
      {error ? <div className="trade-alert error viewer-error">{error}</div>
        : source ? <iframe src={source} title="Trade drawing PDF" />
          : <div className="trade-loading viewer-error">Loading PDF…</div>}
    </main>
  );
}
